export const findAllDraggingPlaceholderElements = (): NodeListOf<HTMLElement> =>
  document.querySelectorAll('[data-draggableplhid]');
